<template>
  <v-form ref="form" class="row ml-0 mr-0">
    <v-text-field
      class="col-12 col-sm-6 col-lg-3"
      v-model="searchData.number"
      label="Nr noty"
    ></v-text-field>

    <v-text-field
      class="col-12 col-sm-6 col-lg-3"
      v-model="searchData.recipient"
      label="Odbiorca"
    ></v-text-field>

    <v-menu
      class="col-6 col-lg-3"
      :close-on-content-click="false"
      v-model="issuedFromPicker"
      lazy
      transition="scale-transition"
      offset-y
      full-width
      min-width="290px"
    >
      <v-text-field
        label="Data wystawienia: od"
        slot="activator"
        v-model="searchData.issued_from"
        browser-autocomplete="off"
        readonly>
      </v-text-field>
      <v-date-picker v-model="searchData.issued_from"
                     @input="issuedFromPicker = false"
                     :max="searchData.issued_to"></v-date-picker>
    </v-menu>

    <v-menu
      class="col-6 col-lg-3"
      :close-on-content-click="false"
      v-model="issuedToPicker"
      lazy
      transition="scale-transition"
      offset-y
      full-width
      min-width="290px"
    >
      <v-text-field
        label="Data wystawienia: do"
        slot="activator"
        v-model="searchData.issued_to"
        browser-autocomplete="off"
        readonly>
      </v-text-field>
      <v-date-picker v-model="searchData.issued_to"
                     @input="issuedToPicker = false"
                     :min="searchData.issued_from"></v-date-picker>
    </v-menu>

    <div class="col-sm-6 col-lg-3">
      <v-autocomplete
        :items="paymentMethods"
        label="Metoda płatności"
        v-model="searchData.payment_method"
        item-text="label"
        item-value="value"
        clearable
      ></v-autocomplete>
    </div>

    <div class="display-flex w-100 justify-content-end">
      <v-btn class="mr-0" color="white" @click="$emit('search', true, searchData)">
        Szukaj
      </v-btn>
    </div>
  </v-form>
</template>

<script>
  export default {
    name: 'DebitNotesSearch',
    props: {
      paymentMethods: { type: Array, default: () => [] },
      propsSearchData: { type: Object, default: () => ({}) },
    },
    data() {
      return {
        issuedFromPicker: false,
        issuedToPicker: false,
        searchData: Object.assign({}, this.$props.propsSearchData),
      };
    },
  };
</script>
